import { useInformationList } from "@/api/services/admin/information";
import { Button } from "@/components/elements/Button";
import { CountTable } from "@/components/elements/CountTable";
import { AppRoutes } from "@/routes/config";
import { Stack, styled } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

type TInformationListTopProps = {};

export const InformationListTop: FC<TInformationListTopProps> = () => {
  const { data } = useInformationList();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <CountTable total={data?.pagination.total} page={data?.pagination.page} perPage={data?.pagination.perPage} />
      <ButtonCreateInformation component={Link} to={AppRoutes.informationCreate}>
        新規作成
      </ButtonCreateInformation>
    </Stack>
  );
};

const ButtonCreateInformation = styled(Button)`
  height: 37px;
  min-width: 60px;
  opacity: 1;
  border-width: 2px;
  gap: 8px;
  padding: 0 22px;
`;
